import { VStack, Text } from '@wegroup/design-system';
import React from 'react';
import { handleResponseLanguage } from '../../../../../../../../i18n';
import {
  FlowsQuestion,
  FlowsQuestionGroup,
} from '../../../../../types/FlowsTypes';
import CompanyScanProgressItem from '../../../../ui/company-scan/components/toolbar/CompanyScanProgressItem';
import CompanyScanToolbarWrapper from '../../../../ui/company-scan/components/toolbar/CompanyScanToolbarWrapper';

interface Props {
  question: FlowsQuestion;
  currentGroups: FlowsQuestionGroup[];
}

const TableItemsModalToolbar: React.FC<React.PropsWithChildren<Props>> = ({
  question,
  currentGroups,
}) => {
  return (
    <CompanyScanToolbarWrapper>
      <VStack align="stretch" flexGrow={1} spacing="6">
        <Text color="gray.500" textStyle="largeBodyMedium">
          {handleResponseLanguage(question.rules.table?.entity_name)}
        </Text>
        <VStack spacing="4" align="stretch">
          {currentGroups.map((group) => (
            <CompanyScanProgressItem key={group.id} group={group} />
          ))}
        </VStack>
      </VStack>
    </CompanyScanToolbarWrapper>
  );
};

export default TableItemsModalToolbar;
